export default "__VITE_PUBLIC_ASSET__0d652eb4__"